/* eslint-disable import/no-cycle */
// Utils
import { isObject } from 'ezyvet-fe-helpers';
import { attachGeneratedObjectIdToValuesInArrayRecursivelyOrReturn } from './attachGeneratedObjectIdToValuesInArrayRecursivelyOrReturn';
import { attachGeneratedObjectIdToObjectRecursivelyOrReturn } from './attachGeneratedObjectIdToObjectRecursivelyOrReturn';
/**
 * Identifies an object and/or nested objects of a value, if the value is a primitive then do
 * nothing.
 *
 * @param {any} value
 * @param {string | null} [pathRelativeToParentObject=null]
 *
 * @return any
 */
export var attachGeneratedObjectIdToValueRecursivelyOrReturn = function (value, pathRelativeToParentObject) {
    if (pathRelativeToParentObject === void 0) { pathRelativeToParentObject = null; }
    if (Array.isArray(value)) {
        return attachGeneratedObjectIdToValuesInArrayRecursivelyOrReturn(value, pathRelativeToParentObject);
    }
    if (isObject(value)) {
        // we have an object commit and return
        return attachGeneratedObjectIdToObjectRecursivelyOrReturn(value, pathRelativeToParentObject);
    }
    return value;
};
//# sourceMappingURL=attachGeneratedObjectIdToValueRecursivelyOrReturn.js.map